import { clsx } from 'clsx'
import { Flag } from 'lucide-react'

interface FlagIconProps {
  flagged: boolean
  onClick: () => void
}

export function FlagIcon({ flagged, onClick }: FlagIconProps) {
  return (
    <button
      type="button"
      aria-label={flagged ? '플래그 해제' : '플래그 설정'}
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      className={clsx(
        'inline-flex flex-shrink-0 items-center justify-center min-w-[44px] min-h-[44px] rounded-xl transition-colors',
        'hover-surface',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500'
      )}
    >
      <Flag
        className={clsx(
          'w-4 h-4 transition-colors',
          flagged ? 'text-danger-500' : 'text-disabled'
        )}
        fill={flagged ? 'currentColor' : 'none'}
        strokeWidth={2}
      />
    </button>
  )
}
